export default __webpack_public_path__ + "static/media/hht1_ep6_minisitcom_01.de184135.png";